export interface SupervisorStreakDay {
    date: string;
    active: boolean;
}

export interface SupervisorStreak {
    current_days: number;
    longest_days: number;
    studied_today: boolean;
    last_activity_date: string | null;
    as_of_date: string;
    timezone: string;
    recent_days: SupervisorStreakDay[];
}

export const emptySupervisorStreak: SupervisorStreak = {
    current_days: 0,
    longest_days: 0,
    studied_today: false,
    last_activity_date: null,
    as_of_date: "",
    timezone: "UTC",
    recent_days: [],
};
